import { IASTIInquiry } from './';

export default {
  path: 'ia-sti-inquiry',
  name: 'IA and STI Inquiry',
  childRoutes: [
    { path: '', name: 'IA and STI Inquiry', component: IASTIInquiry, isIndex: true },
  ],
};


